export const careerModel = {
    name: '',
    email: '',
    phone: '',
    application: null
};
